import globalConstants from "../../globals/GlobalConstants";
import { useEffect, useCallback } from "react";
import "./HomePage.css";
import { useLocation } from "react-router";
import updateDisplayService from "../../services/UpdateDisplayService";
import DisplayComponentHomePage from "./displayComponentHomePage";
import { useTranslation } from "react-i18next";

const HomePage = () => {
    const { i18n } = useTranslation("homePage");
    const { t: tEula } = useTranslation("eula");
    const { t: tPrivacyPolicy } = useTranslation("privacyPolicy");

    const clientId = globalConstants.clientId;
    const oauthRedirectUrl = globalConstants.oauthRedirectUrl;
    const claims =
        "{'id_token': {'email': null, 'preferred_username': null, 'picture': null, 'email_verified': null}}";
    const responseType =
        "code&scope=bits:read+channel:bot+channel:manage:broadcast+channel:manage:extensions+channel:manage:redemptions+channel:read:hype_train+channel:read:redemptions+channel:read:subscriptions+clips:edit+moderation:read+moderator:read:chatters+moderator:read:followers+moderator:read:shoutouts+moderator:manage:announcements+user:edit:broadcast+user:read:email+openid+user_read";
    const loginLink = `https://id.twitch.tv/oauth2/authorize?claims=${claims}&client_id=${clientId}&redirect_uri=${oauthRedirectUrl}&response_type=${responseType}`;

    const location = useLocation();
    const paramsUrl = new URLSearchParams(location.search);
    const params = paramsUrl.get("params");
    const eulaParam = paramsUrl.get("eula");
    const privacyPolicyParam = paramsUrl.get("privacyPolicy");

    // reset cookies
    document.cookie = "twitch_user= ;expires=Thu, 01 Jan 1970 00:00:01 GMT";
    document.cookie = "jwt_token= ;expires=Thu, 01 Jan 1970 00:00:01 GMT";
    document.cookie = "isMonetized=  ;expires=Thu, 01 Jan 1970 00:00:01 GMT";
    document.cookie = "userLogo=  ;expires=Thu, 01 Jan 1970 00:00:01 GMT";

    const showEula = useCallback(() => {
        updateDisplayService.setMessage(tEula("eulaTextKey"));
        updateDisplayService.setTitle(tEula("termsOfServiceTitle"));
        updateDisplayService.onCancel(() => updateDisplayService.clearAll());
    }, [i18n.language]);

    const showPrivacyPolicy = useCallback(() => {
        updateDisplayService.setMessage(tPrivacyPolicy("privacyPolicyTextKey"));
        updateDisplayService.setTitle(tPrivacyPolicy("privacyPolicyTitle"));
        updateDisplayService.onCancel(() => updateDisplayService.clearAll());
    }, [i18n.language]);

    useEffect(() => {
        if (eulaParam === "show") showEula();
        if (privacyPolicyParam === "show") showPrivacyPolicy();
    }, [eulaParam, showEula, privacyPolicyParam, showPrivacyPolicy]);

    return (
        <DisplayComponentHomePage
            showEula={showEula}
            showPrivacyPolicy={showPrivacyPolicy}
            params={params}
            loginLink={loginLink}
        />
    );
};

export default HomePage;
